import React, {useState, useEffect} from "react";
import Button from "olive-react-myoneui/lib/Button";
import { copyIcon } from "../../../constants/icons";
import {convertTimetoAmPm, convertUTCtoLocalTime} from '../../../helpers/dateTimeHelper';
import { calendarModuleName } from '../../../constants/config';
import { useTranslation } from 'react-i18next';

// Add this image fallback component
const ImageWithFallback = ({ src, fallbackSrc, ...props }) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [src]);

  return (
    <img
      src={error ? fallbackSrc : (src || fallbackSrc)}
      onError={() => setError(true)}
      {...props}
    />
  );
};

function EventSlot({ className, event, timeZone }) {
  const { t } = useTranslation(calendarModuleName);
  const days    = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const monthText   = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  let host        = window.location.protocol + '//' +window.location.host;
  let currentUrl  = window.location.href;
  let startTime   = typeof event.startTime !== "undefined" ? event.startTime : "--";
  let endTime     = typeof event.endTime !== "undefined" ? event.endTime : ":--";

  let itemTypes = ['live', 'assignment', 'link', 'Targets', 'Deadlines'];

  let aEndDate   = event.reminder_date;
  aEndDate = convertUTCtoLocalTime(aEndDate, timeZone);
  let month     = aEndDate.getMonth()+1;
  let day       = aEndDate.getDate();
  let year      = aEndDate.getFullYear();
  let endHours  = aEndDate.getHours();
  endHours      = ("0" + endHours).slice(-2);
  let endMinutes = aEndDate.getMinutes();
  endMinutes    = ("0"+endMinutes).slice(-2);
  let convertedAssigmentTime  = convertTimetoAmPm(endHours+':'+endMinutes);

  let eStartTime  = convertUTCtoLocalTime(event.startTime, timeZone);
  let eEndTime    = convertUTCtoLocalTime(event.endTime, timeZone);

  const formattedDate = `${monthText[eStartTime.getMonth()].slice(0, 3)} ${("0" + eStartTime.getDate()).slice(-2)}, ${eStartTime.getFullYear()}`;

  let efullYear    = eStartTime.getFullYear();
  let eEndFullYear   = eEndTime.getFullYear();

  let eMonthIndex     = eStartTime.getMonth();
  let eMonthName      = monthText[eMonthIndex];
  let eEndMonthIndex  = eEndTime.getMonth();
  let eEndMonthName   = monthText[eMonthIndex];

  let eIndex  = eStartTime.getDay();
  let eDay     = days[eIndex];
  let eDate    = eStartTime.getDate();
  let eEndIndex  = eEndTime.getDay();
  let eEndDay    = days[eEndIndex];
  let eEndDate   = eEndTime.getDate();

  let eStartHour  = eStartTime.getHours();
  eStartHour      = ("0" + eStartHour).slice(-2);
  let eStartMinute = eStartTime.getMinutes();
  eStartMinute    = ("0" + eStartMinute).slice(-2);
  let convertedStartTime = convertTimetoAmPm(eStartHour+':'+eStartMinute);

  let eEndHour    = eEndTime.getHours();
  eEndHour        = ("0" + eEndHour).slice(-2);
  let eEndMinute  = eEndTime.getMinutes();
  eEndMinute      = ("0" + eEndMinute).slice(-2);
  let convertedEndTime = convertTimetoAmPm(eEndHour+':'+eEndMinute);

  let live_date  = `${convertedStartTime} - ${convertedEndTime}`;
  if(eDate != eEndDate || efullYear != eEndFullYear || eMonthIndex != eEndMonthIndex){
    live_date = `${eDay}, ${eDate} ${eMonthName} ${convertedStartTime} - ${eEndDay}, ${eEndDate} ${eEndMonthName} ${convertedEndTime}`;
  }

  const defaultEventThumbnail = "https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/default-events.jpg";

  return (
    <div
      className={`${className || ""} ${
        typeof event.itemName !== "undefined" && event.itemName.length % 2 === 0
          ? "mark-success"
          : "mark-progress"
      } event-block liveclass-block information-block information-block-sm-pd py-0 ps-0`}
    >
      <div className="information-wrap">
        <div className="information-holder gap-2">
          <div className="myk__cal_event-img">
            <ImageWithFallback
              src={event?.reminder_image}
              fallbackSrc={defaultEventThumbnail}
              alt="Event" 
            />
          </div>
          <div className="information-detail">
            <div className="myk__event-time-wrapper mb-1">
              <span className="myk__event-time">
                {
                event.itemType === 'live' ? live_date : ( convertedAssigmentTime )
                  
                }
                {/* {typeof event.startTime !== "undefined" ? event.startTime : "--"}
                &nbsp;&nbsp;&nbsp;&nbsp;
                {typeof event.endTime !== "undefined" ? event.endTime : ":--"} */}
              </span>
              {eDate === eEndDate && eMonthIndex === eEndMonthIndex && efullYear === eEndFullYear && (
                <span className="myk__event-month">
                  {formattedDate}
                </span>
              )}
            </div>
            <h3 className="mb-0">
              {typeof event.itemName !== "undefined" ? event.itemName : ""}
            </h3>
          </div>
          {event.itemType && itemTypes.map(t => t.toLowerCase()).includes(event.itemType?.toLowerCase()) && (
            <Button
              variant="outline"
              className="btn-round dark px-3"
              size="sm"
              {...(event.itemLink && {
                onClick: () => {
                  let url = '';
            
                  if (event.product?.includes('eportfolio')) {
                    url = event.itemLink;
                    window.open(url, '_blank');
                    return;
                  }
            
                  if (event.itemType === 'assignment') {
                    url = host + '/materials/course/' + event.item_course_id + '/' + event.item_lecture_id + '/?callback=' + currentUrl;
                    window.location.href = url;
                  } else if (event.itemType === 'live' || event.itemType === 'link') {
                    url = event.itemLink;
                    window.open(url, '_blank');
                  }
                },
              })}
            >
              {event.product?.includes("eportfolio")
              ? t("View")
              : event.itemType === "live"
              ? t("Join")
              : event.itemType === "assignment"
              ? t("Submit")
              : event.itemType === "link"
              ? t("Open")
              : ""}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default EventSlot;
